const reIsBinary = /^0b[01]+$/i
export default reIsBinary
